import SabalPriceSheetActivity from './PriceSheetActivity';

const SabalPriceSheetUpdated = ({ event }: { event: any }) => {
  return (
    <SabalPriceSheetActivity event={event} actionLabel={`Updated a Price Sheet (${event?.data?.diff?.name?.to})`} />
  );
};

export default SabalPriceSheetUpdated;
